import { Avatar } from '@synoptic/ui-kit/avatar/avatar.js';
import { headerAvatar } from '@/components/page-header/drawer-avatar-trigger.css.ts';
import { SidebarDrawer } from '@/components/sidebar-drawer/sidebar-drawer.tsx';
import { useAppLoader } from '@/routes/_app/loader.ts';
import { ProfileMenu } from '@/routes/_app/sidebar/profile-menu.tsx';
import { useAuthGuard } from '../auth-guard/auth-guard-provider';
import { MyAvatar } from '../my-avatar';

export const DrawerAvatarTrigger = () => {
  const { authenticated } = useAppLoader();
  const guard = useAuthGuard();

  if (!authenticated) {
    return (
      <button
        style={{ all: 'unset' }}
        onClick={guard}
        aria-label="Profile menu"
      >
        <Avatar className={headerAvatar} />
      </button>
    );
  }

  return (
    <SidebarDrawer
      trigger={
        <button style={{ all: 'unset' }} aria-label="Profile menu">
          <MyAvatar className={headerAvatar} />
        </button>
      }
    >
      <ProfileMenu opened />
    </SidebarDrawer>
  );
};
